import { render, staticRenderFns } from "./IdentifiersTable.vue?vue&type=template&id=2f0a225a"
import script from "./IdentifiersTable.vue?vue&type=script&lang=ts"
export * from "./IdentifiersTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports